/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * @deprecated obj == null / obj != nullと書いてください
 */
export function isNullOrUndef(obj: any): boolean {
    return obj === null || obj === undefined;
}

export function parseToJson(value: string): any {
    try {
        return JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`${value} is not JSON.`);
        return null;
    }
}

export function isEmptyObject(obj: any): boolean {
    return Object.keys(obj).length === 0;
}
